import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@common/util-foundation';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { FeatureConfigApiService } from '../services/feature-config-api/feature-config-api.service';
import {
  loadFeatureConfig,
  loadFeatureConfigFailure,
  loadFeatureConfigSuccess,
} from './feature-config.actions';

@Injectable()
export class FeatureConfigEffects implements OnInitEffects {
  loadFeatureConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadFeatureConfig),
      exhaustMap(() =>
        this.featureConfigService.getFeatureConfig().pipe(
          map((response) =>
            loadFeatureConfigSuccess({
              response,
            })
          ),
          catchError((error: HttpErrorResponse) => {
            this.handleError();
            return of(loadFeatureConfigFailure({ error }));
          })
        )
      )
    )
  );

  handleError() {
    this.errorService.handleError();
  }

  constructor(
    private actions$: Actions,
    private featureConfigService: FeatureConfigApiService,
    private errorService: ErrorService
  ) {}

  ngrxOnInitEffects(): Action {
    return loadFeatureConfig();
  }
}
